import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Srcollbar from "react-perfect-scrollbar";
import { BsCheckCircle } from "react-icons/bs";
import { FiXCircle } from "react-icons/fi";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

import { getIncidentReportById } from "app/_services/ehs/ehsIncidentServices";
import IncidentEvidences from "./IncidentEvidences";
import {
  initialForm,
  severities,
  evidenceCategories,
  incidentTypes,
  staffType,
  STAFFEMPLOYER,
  FORM_LABEL_OFFICER,
} from "./CONSTANTS";
import {
  contractorDropdownLabel,
  employeeDropdownLabel,
  formatDDMMYYYYbyYYYYMMDD,
  normalizeDateTime,
  userDropdownLabel,
} from "app/_helpers/helper";
import IncidentTimeline from "./IncidentTimeline";
import { getAllAreaOfOperation } from "app/_services/ehs/ehsAreaOfOperationServices";
import Capasview from "../CapasView";
import { getContractor } from "app/_services/Contractor/ContractorService";
import { bodyLabel } from "app/Components/BodyPartComponent/CONSTANT";
import ViewComments from "./ViewComments";
// import { MeterialMasterServices } from "app/_services/ConfigService/MaterialMaster";
import toastr from "toastr";
import CapasViewTable from "../CapasViewTable";
const ViewIncidentReport = ({ match: { params }, history }) => {
  const [form, setForm] = useState({ ...initialForm });
  const [tab, setTab] = useState(0);
  const [evidences, setEvidences] = useState([]);
  const [personalDetails, setPersonalDetails] = useState([]);
  const [vehicleDetails, setVehicleDetails] = useState([]);
  const [assetDetails, setAssetDetails] = useState([]);
  const [spills, setSpills] = useState([]);
  const [capas, setCapas] = useState([]);
  const [area, setArea] = useState([]);
  const [contractors, setContractors] = useState([]);
  const [matDetails, setMatDetails] = useState([
    { id: 1, name: "DTH Drill Machine" },
    { id: 2, name: "Jack hammer" },
    { id: 3, name: "Long Hole/Ring Drilling Machine" },
    { id: 4, name: "Exploration Drill Machine" },
    { id: 5, name: "Excavator" },
    { id: 6, name: "Payloader" },
    { id: 7, name: "Dumper" },
    { id: 8, name: "Tipper-Truck" },
    { id: 9, name: "Buyer's Truck" },
    { id: 10, name: "Explosive Van" },
    { id: 11, name: "Trailer" },
    { id: 12, name: "Dozer" },
    { id: 13, name: "Grader" },
    { id: 14, name: "Mobile Screening Plant" },
    { id: 15, name: "Mobile Crusher Plant" },
    { id: 16, name: "Fixed Crushing & Sizing Plant" },
    { id: 17, name: "Light Vehicle" },
    { id: 18, name: "Over Head Crane" },
    { id: 19, name: "Hoists & Other Cranes" },
    { id: 20, name: "Hydra & Mobile Cranes" },
    { id: 21, name: "Forklift" },
    { id: 22, name: "Pump" },
    { id: 23, name: "Submersible Pump" },
    { id: 24, name: "Sub-Station" },
    { id: 25, name: "Transformer" },
    { id: 26, name: "DG Set" },
    { id: 27, name: "Electrical OH Lines & Cablea" },
    { id: 28, name: "Lathe Machine" },
    { id: 29, name: "Grinding & Cutting Machine" },
    { id: 30, name: "Welding Machine " },
    { id: 31, name: "Compressors" },
    { id: 32, name: "Pressure Tank" },
    { id: 33, name: "Rocker Shovel" },
    { id: 34, name: "Haulage" },
    { id: 35, name: "Locomotive" },
    { id: 36, name: "Winder" },
    { id: 37, name: "Ventilation Main Fan" },
    { id: 38, name: "Auxiliary/Booster Fan" },
    { id: 39, name: "Others" },
  ]);

  useEffect(() => {
    getContractor().then((response) => {
      if (!response?.data) return;

      setContractors(response.data);
    });
  }, []);

  const getAreaandSubArea = (capa) => {
    let areaname = "";
    let sareaname = "";
    const capaData = capa;
    const areaNames = area;

    for (let x of areaNames) {
      if (x.id === capaData.areaId) {
        areaname = x.name;
      }
      for (let y of x.subAreaOfOperation) {
        if (y.id === capaData.subAreaId) {
          sareaname = y.name;
        }
      }
    }

    const obj = {
      area: areaname,
      subArea: sareaname,
    };

    return obj;
  };

  const [mats, setMats] = useState([{ id: 1, name: "EP 1" }]);

  // const [mats, setMats] = useState([]); // Mat === Material Master;
  //const [matDetails, setMatDetails] = useState([{ id: 1, value: "MAT 1" }]); // Mat Details === Material Master Level 4;

  // useEffect(() => {
  //     MeterialMasterServices.getMeterialMaster("filter[status]=1").then((response) => {
  //         if (!response?.data) return;

  //         const detailsArray = [];
  //         response.data.MaterialMaster.forEach((obj) => {
  //             detailsArray.splice(detailsArray.length, 0, ...obj.mat_material_master_level_details.filter((obj) => +obj.status === 1));
  //         });
  //         setMats(response.data.MaterialMaster);
  //         setMatDetails(detailsArray);
  //     });
  // }, []);
  // console.log("capas=",capas)

  useEffect(() => {
    if (!params.id) return;

    getIncidentReportById(params.id, "role=Reporter").then((response) => {
      if (!response?.status) {
        history.push("/health-safety-and-environment/incident-management");
        toastr.error(response?.message || "Something went Wrong");
        return;
      }
      if (!response?.data) return;
      const {
        personalDetails,
        vehicleDetails,
        assetDetails,
        spills,
        evidences,
        capas,
        ...form
      } = response.data;

      setForm((prev) => {
        if (form.site?.siteType === 3) {
          prev.roName = form.site?.parentSite?.name;
          prev.roSiteId = form.site?.parentSite?.siteId;
        } else if (form.site?.siteType === 2) {
          prev.roName = form.site?.name;
          prev.roSiteId = form.site?.siteId;
        } else {
          prev.roName = "";
          prev.roSiteId = "";
        }

        // console.log("evvvvvvvv", evidences);

        return {
          ...prev,
          ...form,
          locationSiteId: form.site?.siteId,
          //staffType: staffType,
          countryMasterId: form?.state.country_master?.id,
          reportDate: normalizeDateTime(form.reportDate),
          incidentDate: normalizeDateTime(form.incidentDate),
          closeIncident: capas?.length ? true : false,
          peopleCount: assetDetails?.length,
        };
      });

      // setForm({ ...form, countryMasterId: form?.state.country_master?.id });
      setEvidences(
        evidences?.filter((data) => data.category === evidenceCategories.report) || []
      );
      setPersonalDetails(personalDetails);
      setAssetDetails(assetDetails);
      setVehicleDetails(vehicleDetails);
      setSpills(spills);
      setCapas(capas);
    });

    getAllAreaOfOperation().then((response) => {
      if (!response?.data) return;
      setArea(response.data);
    });
  }, [params.id]);

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Incident Management",
            path: "/health-safety-and-environment/incident-management",
          },
          // {
          //   name: "My Incidents",
          //   path: "/health-safety-and-environment/incident-management/my-incidents",
          // },
          {
            name: "View",
          },
        ]}
      />
      <div className="healthSafetyEnvironmentWrapper lrgTabberWrapper">
        <div className="hseMenuLinks card">
          <a
            href
            onClick={() => setTab(0)}
            className={`pointer${tab === 0 ? " active" : ""}`}
          >
            Timeline
          </a>
          <a
            href
            onClick={() => setTab(1)}
            className={`pointer${tab === 1 ? " active" : ""}`}
          >
            Incident Info
          </a>
          <a
            href
            onClick={() => setTab(2)}
            className={`pointer${tab === 2 ? " active" : ""}`}
          >
            General Info
          </a>
          <a
            href
            onClick={() => setTab(3)}
            className={`pointer${tab === 3 ? " active" : ""}`}
          >
            Personnel Details
          </a>

          <a
            href
            onClick={() => setTab(4)}
            className={`pointer${tab === 4 ? " active" : ""}`}
          >
            Equipment Details
          </a>
          <a
            href
            onClick={() => setTab(5)}
            className={`pointer${tab === 5 ? " active" : ""}`}
          >
            Vehicle Details
          </a>
          <a
            href
            onClick={() => setTab(6)}
            className={`pointer${tab === 6 ? " active" : ""}`}
          >
            Evidence
          </a>
          {capas.length > 0 && (
            <a
              href
              onClick={() => setTab(7)}
              className={`pointer${tab === 7 ? " active" : ""}`}
            >
              CAPA
            </a>
          )}
          {form.incidentReviewsData?.length > 0 && (
            <a
              onClick={() => setTab(8)}
              className={`pointer${tab === 8 ? " active" : ""}`}
              href
            >
              Workflow Inputs
            </a>
          )}
        </div>
      </div>
      {tab === 0 && (
        <IncidentTimeline
          reportDate={form?.reportDate}
          reporter={form?.reporter}
          investigationCompletionDate={form?.investigationCompletionDate}
          reviewCompletionDate={form?.reviewCompletionDate}
          investigationDetails={form?.investigationDetails}
          reviewer={form?.reviewer}
          closer={form?.closer}
          personalDetails={personalDetails}
          vehicleDetails={vehicleDetails}
          assetDetails={assetDetails}
          spills={spills}
          evidences={evidences}
          investigationCompleted={
            form?.investigationDetails
              ? form?.investigationDetails.investigationCompleted
              : false
          }
          reviewCompleted={form?.reviewCompleted}
          closureCompleted={form?.closureCompleted}
          isAssetIncident={form?.isAssetIncident}
          isPersonalInjury={form?.isPersonalInjury}
          isSpillsIncident={form?.isSpillsIncident}
          isVehicleIncident={form?.isVehicleIncident}
          closureCompletionDate={form?.closureCompletionDate}
          incidentStatus={form?.incidentStatus}
          insuranceApplicable={form?.insuranceApplicable}
          complianceRequired={form?.complianceRequired}
          trainingRequired={form?.trainingRequired}
          witnessStatementRequired={form?.witnessStatementRequired}
          rootCauseAnalysisRequired={form?.rootCauseAnalysisRequired}
          solutionRequired={form?.solutionRequired}
          capaRequired={form?.capaRequired}
          reportEvidencesRequired={form?.reportEvidencesRequired}
          evidencesRequired={form?.evidencesRequired}
          reviewEvidencesRequired={form?.reviewEvidencesRequired}
          incidentId={form?.incidentId}
          incidentDate={form?.incidentDate}
          type={form?.type}
          severity={form?.severity}
          severityPostReview={form?.severityPostReview}
          workArea={form?.workArea}
          area={form.area}
          site={form?.site}
          department={form?.department}
          isCapaPresent={capas.length}
          capaCompletionDate={form?.capaCompletionDate}
          capaCompletedByData={form?.capaCompletedByData}
          finalReviewedByDate={form?.finalReviewedByDate}
          finalReviewedByData={form?.finalReviewedByData}
          reviewedByMMDate={form?.reviewedByMMDate}
          reviewedByMMData={form?.reviewedByMMData}
          reviewedDate={form?.reviewedDate}
          staffData={form?.staffData}
          staffType={form?.staffType}
          otherStaffName={form?.otherStaffName}
          capasList={capas}
          reportAtLabel={FORM_LABEL_OFFICER[form?.reportAtLabel]}
          form={form}
        />
      )}
      {tab === 1 && (
        <div className="card p-3 mt-4">
          <div className="simple-card-title">
            <h3 class="text-capitalize mb-0">Incident Info View</h3>
          </div>
          <div className="ehsFormWrapper">
            <Row>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Incident ID</h5>
                  <p>{form?.incidentId}</p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Incident Type</h5>
                  <p>{incidentTypes[form?.type]}</p>
                </div>
              </Col>
              {/* Add */}
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Incident Severity</h5>
                  <p>{severities[form?.severity]}</p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Incident Date and Time</h5>
                  <p>{formatDDMMYYYYbyYYYYMMDD(form?.incidentDate)}</p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Report Date and Time</h5>
                  <p>{formatDDMMYYYYbyYYYYMMDD(form?.reportDate)}</p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Location Name</h5>
                  <p>{form?.site?.name}</p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Regional Office</h5>
                  <p>
                    {form.site?.siteType === 3
                      ? form?.site?.parentSite?.name
                      : form.site?.siteType === 2
                      ? form.site?.name
                      : ""}
                  </p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Staff Type</h5>
                  <p>{staffType[form?.staffType]}</p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Staff Employer</h5>
                  <p>
                    {form?.staffType === "contractor"
                      ? form?.StaffNameObject?.contractors?.contractorLegalEntity
                      : STAFFEMPLOYER.find((d) => d.id === form?.staffEmployer)
                          ?.contactPerson}
                  </p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Staff Name</h5>
                  <p>
                    {form?.staffType === "employee"
                      ? `${employeeDropdownLabel(form?.staffData)}`
                      : form?.staffType === "contractor"
                      ? `${contractorDropdownLabel(form?.staffData)}`
                      : form?.otherStaffName}
                  </p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Area</h5>
                  <p>{form?.area?.name}</p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Sub Area</h5>
                  <p>{+form?.subAreaId !== 999 ? form?.subArea?.name : "Other"}</p>
                </div>
              </Col>
              {+form?.subAreaId === 999 && (
                <Col lg={3}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Other Sub Area</h5>
                    <p>{form?.otherSubArea}</p>
                  </div>
                </Col>
              )}
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Shift</h5>
                  <p>{form?.shift}</p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Activity</h5>
                  <p>{form?.activity?.name}</p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Sub Activity</h5>
                  <p>{form?.subActivity?.name}</p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Department</h5>
                  <p>{form?.department?.name}</p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Location ID</h5>
                  <p>{form?.locationSiteId}</p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">RO ID</h5>
                  <p>{form?.roSiteId}</p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">Country</h5>
                  <p>{form?.state?.country_master?.name}</p>
                </div>
              </Col>
              <Col lg={3}>
                <div className="form-group viewbox">
                  <h5 className="w-500">State</h5>
                  <p>{form?.state?.name}</p>
                </div>
              </Col>
              {/* <Col lg={3}>
                                <div className="form-group viewbox">
                                    <h5 className="w-500">Function</h5>
                                    <p>{form?.functionData}</p>
                                </div>
                            </Col>
                            <Col lg={3}>
                                <div className="form-group viewbox">
                                    <h5 className="w-500">Specific Work Area</h5>
                                    <p>{form?.workArea?.name}</p>
                                </div>
                            </Col>                             */}
            </Row>
          </div>
        </div>
      )}
      {tab === 2 && (
        <div className="card p-3  mt-4">
          <div className="simple-card-title">
            <h3 class="text-capitalize mb-0">General Info View</h3>
          </div>
          <div className="ehsFormWrapper">
            <Row className="pt-1 mb-3">
              <Col lg={4}>
                <div className="viewbox">
                  <h5>
                    {form?.fireInvolved ? (
                      <BsCheckCircle color={"green"} />
                    ) : (
                      <FiXCircle color={"#b93b26"} />
                    )}
                    Fire Involved
                  </h5>
                </div>
              </Col>
              <Col lg={4}>
                <div className="viewbox">
                  <h5>
                    {form?.facilityOutage ? (
                      <BsCheckCircle color={"green"} />
                    ) : (
                      <FiXCircle color={"#b93b26"} />
                    )}
                    Electrical Shock
                  </h5>
                </div>
              </Col>
              <Col lg={4}>
                <div className="viewbox">
                  <h5>
                    {form?.permanentDisability ? (
                      <BsCheckCircle color={"green"} />
                    ) : (
                      <FiXCircle color={"#b93b26"} />
                    )}
                    Lighting
                  </h5>
                </div>
              </Col>
              <Col lg={4}>
                <div className="viewbox">
                  <h5>
                    {form?.facilityShutdown ? (
                      <BsCheckCircle color={"green"} />
                    ) : (
                      <FiXCircle color={"#b93b26"} />
                    )}
                    Due to moving equipment
                  </h5>
                </div>
              </Col>
              <Col lg={4}>
                <div className="viewbox">
                  <h5>
                    {form?.explosion ? (
                      <BsCheckCircle color={"green"} />
                    ) : (
                      <FiXCircle color={"#b93b26"} />
                    )}
                    Explosive Involved
                  </h5>
                </div>
              </Col>
              <Col lg={4}>
                <div className="viewbox">
                  <h5>
                    {form?.longDurationFire ? (
                      <BsCheckCircle color={"green"} />
                    ) : (
                      <FiXCircle color={"#b93b26"} />
                    )}
                    Fall from height
                  </h5>
                </div>
              </Col>
              <Col lg={4}>
                <div className="viewbox">
                  <h5>
                    {form?.equipmentFailure ? (
                      <BsCheckCircle color={"green"} />
                    ) : (
                      <FiXCircle color={"#b93b26"} />
                    )}
                    Vehicle Collision/toppling
                  </h5>
                </div>
              </Col>
              <Col lg={4}>
                <div className="viewbox">
                  <h5>
                    {form?.fallOfObject ? (
                      <BsCheckCircle color={"green"} />
                    ) : (
                      <FiXCircle color={"#b93b26"} />
                    )}
                    Fall of object
                  </h5>
                </div>
              </Col>
              <Col lg={4}>
                <div className="viewbox">
                  <h5>
                    {form?.inundation ? (
                      <BsCheckCircle color={"green"} />
                    ) : (
                      <FiXCircle color={"#b93b26"} />
                    )}
                    Inundation
                  </h5>
                </div>
              </Col>

              <Col lg={4}>
                <div className="viewbox">
                  <h5>
                    {form?.alcoholViolator ? (
                      <BsCheckCircle color={"green"} />
                    ) : (
                      <FiXCircle color={"#b93b26"} />
                    )}
                    Alcohol Violator
                  </h5>
                </div>
              </Col>
              <Col lg={4}>
                <div className="viewbox">
                  <h5>
                    {form?.ppeViolator ? (
                      <BsCheckCircle color={"green"} />
                    ) : (
                      <FiXCircle color={"#b93b26"} />
                    )}
                    PPE Violator
                  </h5>
                </div>
              </Col>
              <Col lg={4}>
                <div className="viewbox">
                  <h5>
                    {form?.unfitBuyerTruck ? (
                      <BsCheckCircle color={"green"} />
                    ) : (
                      <FiXCircle color={"#b93b26"} />
                    )}
                    Unfit Buyer's Truck
                  </h5>
                </div>
              </Col>
              <Col lg={4}>
                <div className="viewbox">
                  <h5>
                    {form?.unfitHEMM ? (
                      <BsCheckCircle color={"green"} />
                    ) : (
                      <FiXCircle color={"#b93b26"} />
                    )}
                    Unfit HEMM
                  </h5>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5>Indirect Losses</h5>
                  <p>{form?.indirectLosses}</p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5>Status of the Facility</h5>
                  <p>{form?.facilityStatus}</p>
                </div>
              </Col>
              <Col lg={4}>
                <div className="form-group viewbox">
                  <h5>Whether similar incident happened in the past at same location </h5>
                  <p>{form?.similarIncidentHappened}</p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="form-group viewbox">
                  <h5>Incident - Short Summary</h5>
                  <p>{form?.summary}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div className="form-group viewbox">
                  <h5>Incident - Detailed Description</h5>
                  <p>{form?.description}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div className="form-group viewbox">
                  <h5>Immediate measures/actions taken, if any</h5>
                  <p>{form?.measuresOrActions}</p>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}
      {tab === 3 && (
        <div className="card p-3 mt-4">
          <div className="simple-card-title">
            <h3 class="text-capitalize mb-0">Personnel Details View</h3>
          </div>
          <div className="ehsFormWrapper">
            {form?.isPersonalInjury ? (
              <div className="mb-4 justify-content-start align-items-center">
                <Col lg={3} className="pl-0">
                  <label>Number of people involved: {form?.peopleCount}</label>
                </Col>
              </div>
            ) : (
              <div className="text-danger">Not Applicable</div>
            )}
            {personalDetails?.length > 0 && (
              <div className="w-100">
                <div className="table-responsive drillingPlan-plannedEdit">
                  <Srcollbar className="workoverCategoryScroll">
                    <table id="user_table" className="table table-bordered mb-0">
                      <thead>
                        <tr>
                          <th scope="col"></th>
                          <th
                            scope="col"
                            colSpan="5"
                            className="text-center personnelDetails"
                          >
                            Personnel Details
                          </th>
                          <th
                            scope="col"
                            colSpan="5"
                            className="text-center injuryDetails"
                          >
                            Injury/Illness Details
                          </th>
                        </tr>
                        <tr style={{ background: "#f5f5f5" }}>
                          <th scope="col">S.No.</th>
                          <th scope="col">Type</th>
                          <th scope="col" className="w-150">
                            Name
                          </th>
                          {/* <th scope="col" className="w-150">
                            Phone
                          </th> */}
                          <th scope="col" className="w-150">
                            Employer
                          </th>
                          <th scope="col" className="w-150">
                            ID
                          </th>
                          <th
                            scope="col"
                            className="w-150"
                            style={{ borderRight: "3px solid #dee2e6" }}
                          >
                            Age
                          </th>
                          <th
                            scope="col"
                            style={{ maxWidth: "150px", minWidth: "150px" }}
                          >
                            Type
                          </th>
                          <th
                            scope="col"
                            style={{ maxWidth: "120px", minWidth: "120px" }}
                          >
                            Severity
                          </th>
                          <th scope="col">Body Parts Involved</th>
                          <th
                            scope="col"
                            style={{ maxWidth: "150px", minWidth: "150px" }}
                          >
                            Outcome
                          </th>
                          <th scope="col">LTI Hours</th>
                        </tr>
                      </thead>
                      <tbody>
                        {personalDetails?.map((data, index) => (
                          <tr key={index}>
                            {console.log(
                              "data.bodyParts?.split(",
                              ")",
                              data.bodyParts?.split(",")
                            )}

                            <th>{index + 1}</th>
                            <td>{data.type}</td>
                            <td>{data.name}</td>
                            <td>
                              {data.type === "Contractor"
                                ? contractors.find((d) => d.id === +data.employer)
                                    ?.contractorLegalEntity
                                : data.employer}
                            </td>
                            <td>{data.userId}</td>
                            {/* <td>{data.phone}</td> */}
                            <td style={{ borderRight: "3px solid #dee2e6" }}>
                              {data.age}
                            </td>
                            <td>{data.injuryType}</td>
                            <td>{severities[data.severity]}</td>
                            <td>
                              <BodyPartView bodyParts={data?.bodyParts} />
                            </td>
                            <td>{data.outcome}</td>
                            <td>{data.ltiHours} Hour(s)</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Srcollbar>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {tab === 4 && (
        <div className="card p-3 mt-4">
          <div className="simple-card-title">
            <h3 class="text-capitalize mb-0">Equipment Details View</h3>
          </div>
          <div className="ehsFormWrapper">
            {assetDetails.length > 0 ? (
              <div className="w-100">
                <div className="table-responsive">
                  <table id="user_table" className="table table-bordered mb-3 tblBg">
                    <thead style={{ background: "#f5f5f5" }}>
                      <tr>
                        <th scope="col">S.No.</th>
                        <th scope="col">Equipment Type</th>
                        <th scope="col">Equipment SKU (if Known)</th>
                        <th scope="col">Equipment Name (if Known)</th>
                        <th scope="col">Equipment Incident Details</th>
                        <th scope="col">Equipment Damage (Y/N)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assetDetails?.map((data, index) => {
                        const matObj = matDetails.find((d) => d.id === +data.type);
                        return (
                          <tr key={index}>
                            <th>{index + 1}</th>
                            <td>{matObj?.name}</td>
                            <td>
                              <div>{data.sku}</div>
                              {/* {data.sku &&
                                                            (() => {
                                                                const levelFour = matDetails.find((obj) => obj.id === +data.detailsId || obj.sku.toLowerCase() === data.sku.toLowerCase());
                                                                if (!levelFour) return;
                                                                const levelThree = mats.find((obj) => obj.id === +levelFour.matMaterialMasterId);
                                                                if (!levelThree) return;
                                                                const levelTwo = mats.find((obj) => obj.unique_code === levelThree.parent_code);
                                                                if (!levelTwo) return;
                                                                const levelOne = mats.find((obj) => obj.unique_code === levelTwo.parent_code);
                                                                if (!levelOne) return;

                                                                return (
                                                                    <div className="small text-center">
                                                                        {levelOne.category} - {levelTwo.category} - {levelThree.category}
                                                                    </div>
                                                                );
                                                            })()} */}
                            </td>
                            <td>{data.name}</td>
                            <td>{data.details}</td>
                            <td>{data.damage}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="text-danger">Not Applicable</div>
            )}
          </div>
        </div>
      )}
      {tab === 5 && (
        <div className="card p-3 mt-4">
          <div className="simple-card-title">
            <h3 class="text-capitalize mb-0">Vehicle Details View</h3>
          </div>
          <div className="ehsFormWrapper">
            {vehicleDetails.length > 0 ? (
              <div className="w-100">
                <div className="table-responsive drillingPlan-plannedEdit">
                  <table id="user_table" className="table table-bordered mb-3">
                    <thead style={{ background: "#f5f5f5" }}>
                      <tr>
                        <th scope="col">S.No.</th>
                        <th scope="col">Vehicle No.</th>
                        <th scope="col">Vehicle Type</th>
                        <th scope="col">Vehicle Owner</th>
                        <th scope="col">Driver Name</th>
                        <th scope="col">Observation</th>
                        <th scope="col">Insurance Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {vehicleDetails?.map((data, index) => (
                        <tr key={index}>
                          <th>{index + 1}</th>
                          <td>{data.number}</td>
                          <td>{data.type}</td>
                          <td>{data.owner}</td>
                          <td>{data.driverName}</td>
                          <td>{data.observation}</td>
                          <td>{data.insuranceStatus}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="text-danger">Not Applicable</div>
            )}
          </div>
        </div>
      )}

      {tab === 6 && (
        <div className="card p-3 mt-4">
          <div className="simple-card-title">
            <h3 class="text-capitalize mb-0">Incident Evidence</h3>
          </div>
          <div className="ehsFormWrapper">
            {evidences.length > 0 ? (
              <div className="w-100">
                <IncidentEvidences dataArray={evidences} viewOnly />
              </div>
            ) : (
              <div className="text-danger">Not Applicable</div>
            )}
          </div>
        </div>
      )}

      {tab === 7 && (
        <div className="card p-3 mt-4">
          <div className="simple-card-title">
            <h3 class="text-capitalize mb-0">Incident CAPA</h3>
          </div>
          <div className="ehsFormWrapper">
            {capas.length > 0 ? (
              // <Capasview approveRejectView={false} capas={capas} form={form} />
              <CapasViewTable capas={capas} form={form} />
            ) : (
              <div className="text-danger">Not Applicable</div>
            )}
          </div>
        </div>
      )}

      {tab === 8 && (
        <>
          <Col lg={12} className="pt-3">
            <ViewComments
              comments={form.incidentReviewsData ? form.incidentReviewsData : []}
            />
          </Col>
        </>
      )}
      <div className="mt-4 text-center">
        <span className="btn btn-secondary mx-2" onClick={() => history.goBack()}>
          Go Back
        </span>
      </div>
    </>
  );
};

export const BodyPartView = ({ bodyParts }) =>
  bodyParts
    ? bodyParts?.split(",")?.map((d, i) => (
        <span>
          {i !== 0 && ","}
          {bodyLabel[d]}
        </span>
      ))
    : "";

export default ViewIncidentReport;
